import useFetch from '@hooks/useFetch';
import { emptyList } from '@constants/empty';

export const getKey = (topicUID) =>
  `v2/quizzes/similar-topic-practice/?parent_uid=${topicUID}&language=0`;

const useSimilarTopicPractice = (
  topicUID,
  options = { revalidateOnMount: false, fallbackData: undefined }
) => {
  const key = getKey(topicUID);
  const {
    data: similarTopicPractice,
    isValidating,
    mutate,
    ...rest
  } = useFetch(
    key,
    {},
    {
      revalidateOnMount: options.revalidateOnMount,
      fallbackData: options.fallbackData
    }
  );
  return {
    key,
    similarTopicPractice: similarTopicPractice || emptyList,
    mutate,
    isValidating,
    ...rest
  };
};

export default useSimilarTopicPractice;
